export const state = () => ({
  siteURL: '',
  calendarDate: null,
  downloadList: [],
  surveyInfo: null,
  surveyFloorId: null,
  surveyFloors: [],
  surveySections: [],
  surveyCompletedSection: '',
  isSurveyShown: false,
})

export const mutations = {
  updateCalendarDate(state, value) {
    state.calendarDate = value
  },
  updateDownloadList(state, value) {
    state.downloadList = value
  },
  updateSurveyInfo(state, value) {
    state.surveyInfo = value
  },
  updateSurveyFloorId(state, value) {
    state.surveyFloorId = value
  },
  updateSurveyFloors(state, value) {
    state.surveyFloors = value
  },
  updateSurveySectons(state, value) {
    state.surveySections = value
  },
  updateSurveyShown(state, value) {
    state.isSurveyShown = value
  },
  updateSurveyCompletedSection(state, value) {
    state.surveyCompletedSection = value
  },
}

export const actions = {
  async fetchSurveyFloors({ commit }, params) {
    const res = await this.$axios.$get('/onboarding-survey/floors')
    const { floors } = res.data

    commit('updateSurveyFloors', floors)

    return floors
  },
}
